(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-asymmetrical-split-slider"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('[data-section-id="{{ section.id }}"]');
  const sliderContent = section?.querySelector('.blog-asymm-split-slider__content');
  if (!sliderContent) return;

  
  if (sliderContent) {
    // Add keyboard navigation for scrollable content
    sliderContent.addEventListener('keydown', function(e) {
      const scrollAmount = 100;
      
      // Space, Page Down, Down Arrow - scroll down
      if (e.key === ' ' || e.key === 'PageDown' || e.key === 'ArrowDown') {
        e.preventDefault();
        this.scrollTop += (e.key === 'PageDown' ? this.clientHeight * 0.9 : scrollAmount);
      }
      // Page Up, Up Arrow - scroll up
      else if (e.key === 'PageUp' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.scrollTop -= (e.key === 'PageUp' ? this.clientHeight * 0.9 : scrollAmount);
      }
      // Home - scroll to top
      else if (e.key === 'Home') {
        e.preventDefault();
        this.scrollTop = 0;
      }
      // End - scroll to bottom
      else if (e.key === 'End') {
        e.preventDefault();
        this.scrollTop = this.scrollHeight;
      }
    });
    
    // Announce to screen readers when the scrollable region is focused
    sliderContent.addEventListener('focus', function() {
      const scrollAnnounce = document.createElement('div');
      scrollAnnounce.setAttribute('role', 'status');
      scrollAnnounce.setAttribute('aria-live', 'polite');
      scrollAnnounce.className = 'sr-only';
      scrollAnnounce.textContent = 'Scrollable content area. Use arrow keys to navigate.';
      document.body.appendChild(scrollAnnounce);
      
      setTimeout(function() {
        document.body.removeChild(scrollAnnounce);
      }, 1000);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-navigation"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('[data-section-id="{{ section.id }}"]');
  const container = section?.querySelector('.category-nav__container');
  if (!container) return;

  
  container.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const scrollAmount = e.key === 'ArrowRight' ? 100 : -100;
      container.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              window.preloadImages(this);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              window.preloadImages(this);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-pdp-showcase"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('[data-section-id="{{ section.id }}"]');
  const grid = section?.querySelector('.product-showcase__grid');
  if (!grid) return;

  
  // Keyboard navigation for mobile scroll
  grid.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const scrollAmount = e.key === 'ArrowRight' ? grid.clientWidth * 0.85 : -(grid.clientWidth * 0.85);
      grid.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  });

  // Ensure grid items are focusable
  const items = grid.querySelectorAll('.product-showcase__link');
  items.forEach(item => {
    item.setAttribute('tabindex', '0');
  });
});

  } catch(e) { console.error(e); }
})();
})();
